<template>
  <div>
    <el-dialog
        class="model-edit"
        title="企业管理员"
        v-if="adminVisible"
        width="950px"
        :visible.sync="adminVisible"
        :close-on-click-modal="false"
        :before-close="adminVisibleClose"
      >
      <el-table
          :row-key="(row) => row.id"
          :data="adminList"
          highlight-current-row
          v-loading="userLoading"
          style="width: 100%"
          ref="userList"
        >
        
          </el-table-column>
          <el-table-column prop="phone" label="账号" min-width="130">
          </el-table-column>
          <el-table-column
            prop="name"
            label="姓名"
            min-width="100"
            xshow-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="softtype"
            label="软件类型"
            min-width="120"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="company"
            label="企业"
            min-width="160"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="intime"
            label="注册时间"
            min-width="160"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            label="操作"
            min-width="160"
            show-overflow-tooltip
          >
          <template slot-scope="scope">
            <el-button type="danger" plain size="small" @click="handleDel(scope.$index, scope.row)">删除</el-button>
          </template>
          </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer" style="text-align: right">
          <el-button @click.native="adminVisibleClose">取消</el-button>
          <el-button
            type="primary"
            @click.native="addAdmin"
            >新增</el-button>
          <el-button
            type="primary"
            @click.native="orderUserSubmit"
            >确定</el-button
          >
        </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  API_Admin
} from "../../../api/index.js";
export default {
  props:{
    adminVisible:{
      type:Boolean,
      default:false
    },
    companyId:{
      type:String,
      default:''
    },
    UserSelection:{
      type:Array,
      default:()=>[]
    }
  },
  data(){
    return{
        userSelection:[],
        adminList:[],
        userLoading:false,
        orderLoading:false,
        checkCode:'',
        token:''
    }
  },
  watch:{
    UserSelection:function(val){
      this.adminList = this.adminList.concat(val)
    }
  },
  mounted(){
    this.getCookie();
    this.getCompanyManage();
  },
  methods:{
    //读取cookie
    getCookie: function() {
        if (document.cookie.length > 0) {
            var arr = document.cookie.split('; ');
            for (var i = 0; i < arr.length; i++) {
                var arr2 = arr[i].split('=');
                if (arr2[0] == 'dnnyptadmin_token') {
                    this.token = arr2[1];
                } else if (arr2[0] == 'dnnyptadmin_checkCode') {
                    this.checkCode = arr2[1];
                } 
            }
        }
    },
    addAdmin(){
      this.$emit("addAdmin")
    },
    adminVisibleClose(){
      this.$emit("adminVisibleClose")
    },
    getCompanyManage(id) {
      var param = {
        companyId: this.companyId,
        token:this.token,
        checkCode:this.checkCode,
      };
      this.userLoading = true;
      API_Admin.getCompanyManage(param).then((res) => {
        if (res.data.code == 200) {
          this.adminList = res.data.data;
        }
        this.userLoading = false;
      });
    },
    handleDel(index,row){
        this.$confirm("确认删除吗?", "提示", {
        type: "warning",
        })
        .then(() => {
          this.adminList.splice(index,1)
        })
    },
    orderUserSubmit(){
        this.$emit("orderUserSubmit",this.adminList)
    }
  }
}
</script>
<style scoped lang="scss">

</style>


// WEBPACK FOOTER //
// addAdmin.vue?77de8700